'use client';
import { CollectionBreadcrumbs as Shared } from '@launchstore/shared-puck';
export const CollectionBreadcrumbs: any = Shared;
export default CollectionBreadcrumbs;
